import { AnalyticsEvent } from "@lonelyplanet/dotcom-analytics";
import * as React from "react";
import Booking from "./booking";
var BookingActivity = function (_a) {
    var discountedPrice = _a.discountedPrice, price = _a.price, url = _a.url, provider = _a.provider, rating = _a.rating;
    return (React.createElement(Booking, null,
        price &&
            React.createElement(Booking.Price, { labelBefore: "from", originalPrice: discountedPrice ? price : null }, discountedPrice ? discountedPrice : price),
        React.createElement(AnalyticsEvent, { render: function (track) { return (React.createElement(Booking.Button, { href: url, onClick: function () {
                    track({
                        bookingProvider: provider,
                        event: "activity booking click",
                        "gtm.element": "Booking.Button",
                        "gtm.elementText": "Check prices and availability",
                    });
                } }, "Check prices and availability")); } }),
        rating &&
            React.createElement(Booking.Rating, null, rating),
        React.createElement(Booking.Provider, { provider: provider })));
};
export default BookingActivity;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/booking/bookingActivity.tsx
// module id = eF97
// module chunks = 2